var _path, _path2, _path3, _rect, _rect2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.12402 2.88496C5.12402 2.39621 5.52023 2 6.00898 2H15.832L21.2302 7.75221V21.115C21.2302 21.6038 20.834 22 20.3453 22H6.00898C5.52023 22 5.12402 21.6038 5.12402 21.115V2.88496Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2305 7.75228V13.062L15.9716 7.75228L21.2305 7.75228Z",
    fill: "#CAD1D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8311 7.75221V2L21.2293 7.75221H15.8311Z",
    fill: "#50BEE8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.12402,
    y: 18.46,
    width: 11.3274,
    height: 1.9469,
    fill: "#CAD1D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11.9116,
    width: 13.4513,
    height: 7.25664,
    rx: 0.353982,
    fill: "#50BEE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36165 14.3977V17.7959H5.84893V14.3977H6.36165ZM7.10833 14.3977H7.73056L8.81242 17.0393H8.85225L9.9341 14.3977H10.5563V17.7959H10.0685V15.3368H10.037L9.03477 17.7909H8.6299L7.62769 15.3352H7.59616V17.7959H7.10833V14.3977ZM13.6016 15.4712C13.5695 15.3706 13.5263 15.2804 13.4721 15.2008C13.419 15.12 13.3554 15.0514 13.2813 14.995C13.2072 14.9375 13.1226 14.8938 13.0274 14.8639C12.9334 14.8341 12.83 14.8191 12.7172 14.8191C12.5258 14.8191 12.3532 14.8684 12.1995 14.9668C12.0457 15.0653 11.924 15.2096 11.8344 15.3999C11.7459 15.589 11.7017 15.8208 11.7017 16.0951C11.7017 16.3706 11.7465 16.6034 11.8361 16.7937C11.9257 16.984 12.0485 17.1283 12.2044 17.2268C12.3604 17.3252 12.5379 17.3744 12.7371 17.3744C12.9218 17.3744 13.0827 17.3368 13.2199 17.2616C13.3582 17.1864 13.4649 17.0802 13.5402 16.943C13.6165 16.8047 13.6547 16.6421 13.6547 16.4552L13.7874 16.4801H12.815V16.057H14.1508V16.4436C14.1508 16.729 14.0899 16.9768 13.9683 17.1869C13.8477 17.396 13.6806 17.5575 13.4672 17.6715C13.2548 17.7854 13.0114 17.8424 12.7371 17.8424C12.4295 17.8424 12.1596 17.7716 11.9273 17.63C11.6961 17.4884 11.5158 17.2876 11.3864 17.0276C11.257 16.7666 11.1923 16.4568 11.1923 16.0984C11.1923 15.8274 11.2299 15.5841 11.3051 15.3684C11.3803 15.1526 11.486 14.9696 11.622 14.8191C11.7592 14.6676 11.9201 14.552 12.1049 14.4723C12.2907 14.3916 12.4937 14.3512 12.7138 14.3512C12.8975 14.3512 13.0684 14.3783 13.2266 14.4325C13.3858 14.4867 13.5274 14.5636 13.6513 14.6632C13.7763 14.7627 13.8798 14.8811 13.9616 15.0182C14.0435 15.1543 14.0988 15.3053 14.1275 15.4712H13.6016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.4c70523d5ddfdfee2e96c14f8391c29e.svg";
export { ForwardRef as ReactComponent };